import {combineReducers} from 'redux';
import appraisalReducer from "./appraisal.reducer";
import leadReducer from "./lead.reducer";
import mainReducer from "./main.reducer";
import userReducer from "./user.reducer";


export const reducer = combineReducers({
    userReducer, leadReducer, mainReducer,
    appraisalReducer
});
export type RootState = ReturnType<typeof reducer>
